export default __webpack_public_path__ + "static/media/btmsIllustration.75068a32.svg";